import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=6516923a&scoped=true&"
import script from "./Dash.vue?vue&type=script&lang=js&"
export * from "./Dash.vue?vue&type=script&lang=js&"
import style0 from "./Dash.vue?vue&type=style&index=0&id=6516923a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6516923a",
  null
  
)

export default component.exports